import InputTel from './InputTel.jsx';

export default InputTel